export var RowDirection=function(RowDirection){RowDirection["Row"]="row";RowDirection["RowReverse"]="row-reverse";return RowDirection;}({});